import { DatePipe as NgDatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { dateFormat } from '@core/config';

@Pipe({
    name: 'waiDate',
    standalone: false
})
export class DatePipe extends NgDatePipe implements PipeTransform {
  public transform(value: Date | string | number, format?: string, timezone?: string, locale?: string): string | null;
  public transform(value: null | undefined, format?: string, timezone?: string, locale?: string): null;
  public transform(value: Date | string | number, format: string = dateFormat, timezone?: string, locale?: string): string | null {
    return super.transform(value, format, timezone, locale);
  }
}
